export default from './RealEstateAgentRegistration';



// WEBPACK FOOTER //
// ./src/components/SignUp/components/RealEstateAgentRegistration/index.js